// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__eCRlp","footlinks":"Footer_footlinks__oBiiS","copy":"Footer_copy__ox9Eq"};